import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from "react-select";
import AdSense from 'react-adsense';
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext.js";
import { MoonLoader } from "react-spinners";

import Table_accounts from "./table";

const Muataikhoan = () => {
    const navigate = useNavigate();
    const [chedomuaacc, setChedomuaacc] = useState('');
    const [luachonacc, set_luachonacc] = useState(0);
    const [hientkclone, setHientkclone] = useState(null);
    const [account, setaccount] = useState(null);
    const [idservice, setIdservice] = useState(null);
    const [clonetruoc, setClonetruoc] = useState(null);
    const [category, set_category] = useState('');
    const [damualendau, setDamualendau] = useState(false);
    const [clonethem, setClonethem] = useState(null);
    const [isOpen, setIsOpen] = useState(true);
    const [dasaochep, set_dasaochep] = useState(null);
    const [nutxuly, setnutxuly] = useState(0);
    const [options, set_options] = useState('');
    const [data_acount, set_data_acount] = useState(null);

    function switch_router(link) {
        navigate(link);
    };
    const muahang = (id) => {
        console.log(id);
        setnutxuly(1);
        set_dasaochep('Please wait a moment 😊');
        setIdservice(id);

        if (!id) {
            alert('Please điền đầy đủ thông tin');
            setnutxuly(0);
            return;
        }
        const apikey = Cookies.get('apikey');
        axios.post('https://hust.media/api/orders/account/sellers/me/account.php', {
            chedo: 'muaacc',
            service: id,
            apikey: apikey,
            amount: 1,
        })
            .then(response => {
                console.log(response.data);
                testFunction1(response);
                setnutxuly(0);
            })
            .catch(error => console.log(error));
    };

    const handleChange = (selectedOption) => {
        set_luachonacc(0);
        setDamualendau(false);
        setIsOpen(false);
        setChedomuaacc(selectedOption.value);
        if (!selectedOption.value) {
            alert('Please điền đầy đủ thông tin');
            return;
        }
        set_category(selectedOption);
        axios.post('https://hust.media/api/orders/account/sellers/me/account.php', {
            chedo: 'laytrangthai',
            chedomuaacc: selectedOption.value,
            id_service: selectedOption.id
        })
            .then((response) => {
                testFunction2(response);
            })
            .catch((error) => {
                alert_error(error);
                set_luachonacc(1);
            });

    };

    const testFunction1 = (response) => {
        set_dasaochep('Xử lý xong');
        const info = response.data;
        if (info.status !== '1') {
            Swal.fire(info.message);
        } else {
            const apikey = Cookies.get('apikey');
            axios.post('https://hust.media/api/orders/account/sellers/me/account.php', {
                chedo: 'laythongtin',
                apikey: apikey,
            })
                .then(response => {
                    console.log(response.data);
                    testFunction3(response);
                })
                .catch(error => alert_error(error));

            setHientkclone(1);
            alert_success('Mua thành công');
            setDamualendau(true);
            setaccount(info);
        }
    };

    const testFunction2 = (response) => {
        set_luachonacc(1);
        let data_acount = JSON.stringify(response.data);
        data_acount = data_acount.replace('tds', 'hust media');
        data_acount = data_acount.replace('TDS', 'hust media');
        data_acount = data_acount.replace('Tds', 'hust media');
        data_acount = data_acount.replace('Ttc', 'hust media');
        data_acount = data_acount.replace('TTC', 'hust media');
        data_acount = data_acount.replace('ttc', 'hust media');
        data_acount = JSON.parse(data_acount);
        set_data_acount(data_acount);
        console.log(data_acount);
    };

    const testFunction3 = (response) => {
        const info = response.data;
        setClonetruoc(info.truoc);
        setClonethem(info.them);
    };

    useEffect(() => {
        setTimeout(() => {
            // Your selectpicker initialization code here
            // You can use useRef to access the DOM element for selectpicker
            // Example: const selectRef = useRef(null);
            //          $(selectRef.current).selectpicker('refresh');
        }, 300);
    }, []);
    const CustomOption = ({ innerProps, label, data }) => (
        <div className="px-2 py-1 flex text-center items-center" {...innerProps}>
            {data.text}&emsp;
            {data.img && (
                <img src={data.img} className="h-6" alt="Option Img" />
            )}
        </div>
    );

    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const CustomSingleValue = ({ innerProps, label, data }) => (
        <div className="flex items-center -mt-6" >
            {options.find(option => option.id === category.id)?.text}
            &emsp;
            {category.img && (
                <img src={options.find(option => option.id === category.id)?.img} className="h-6" alt="Selected Img" />
            )}
        </div>
    );
    function saochep() {
        alert_success('Đã sao chép');
        window.saochepnative(clonethem);
    };
    function laydulieu() {
        axios
            .get('https://hust.media/api/orders/account/sellers/me/account_category.php')
            .then(response => (set_options(response.data)))
            .catch(error => console.log(error))
    };
    useEffect(() => {
        laydulieu();
    }, []);



    return (
        <>
            {
                !options ? (<>
                    <div className="flex justify-center items-center mt-10">
                        <MoonLoader size={65} color="#0000da" speedMultiplier='0.8' />  </div>
                </>) : (<>
                    <div className="max-h-16 ">
                        <div className="cards">
                            {/* Adsense component */}
                        </div>

                        <div className="col mt-0">
                            <div className="mt-2 mx-2 items-center justify-center from-teal-100 via-teal-300 to-teal-500">

                                <div className="w-full max-w-lg px-4 py-3 mx-auto bg-white rounded-lg shadow-xl">

                                    <div className="max-w-md mx-auto space-y-6">

                                        <div className="mx-auto mt-0  flex  flex-col  items-center justify-center ">
                                            <label htmlFor="countries2" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Chọn nền tảng</label>
                                            <Select
                                                id="countries2"
                                                className="w-full max-w-xl"
                                                options={options}
                                                onChange={handleChange} // Assuming onChange is a function in your component
                                                name="nhamang"
                                                value={options.find(option => option.id == category.id)} // Assuming chedomuaacc is a state variable in your component
                                                components={{
                                                    Option: CustomOption, // You can define a custom Option component if needed
                                                    SingleValue: CustomSingleValue,
                                                }}
                                                menuPlacement="auto" // This will attempt to display the menu above or below based on available space
                                                maxMenuHeight={700} // Set a large value to ensure all items are displayed without a scrollbar
                                                menuIsOpen={isOpen}
                                                onBlur={handleBlur}
                                                onFocus={handleFocus}
                                                onMenuOpen={handleMenuOpen}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={true}
                                                isRtl={false}
                                                isSearchable={false}
                                            />
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* Modal section */}
                        {hientkclone === 1 && damualendau === true && (
                            <div className="mt-2 mb-1 relative py-3 sm:max-w-xl sm:mx-auto bg-gray-100 p-2 rounded-md shadow-md">
                                <h2 className="text-xl font-semibold mb-2 ml-2">Thông Tin Tài Khoản Đã Mua</h2>
                                <div className="flex items-center mb-0">
                                    <div className="ml-4">
                                        <div className="font-bold text-base text-gray-600 text-wrap break-all">{clonethem}</div>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <div className="ml-auto">
                                        <button
                                            onClick={() => saochep()}
                                            className="px-3 py-1 bg-blue-200 text-black text-base rounded-md hover:bg-blue-300 focus:outline-none focus:ring focus:border-blue-300"
                                        >
                                            Sao Chép
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {luachonacc == 0 && (<>  <div className="flex justify-center items-center mt-10">
                            <MoonLoader size={65} color="#0000da" speedMultiplier='0.8' />  </div></>
                        )}
                        {luachonacc == 1 && (
                            <div>
                                <Table_accounts
                                    data_acount={data_acount}
                                    set_data_acount={set_data_acount}
                                    nutxuly={nutxuly}
                                    muahang={muahang}
                                    idservice={idservice}
                                    dasaochep={dasaochep}
                                    mode='orders'
                                />

                                {hientkclone === 1 && damualendau === true && (
                                    <div className="mt-2 mb-1  relative py-3 sm:max-w-xl sm:mx-auto bg-gray-100 p-2 rounded-md shadow-md">
                                        <h2 className="text-xl font-semibold mb-2 ml-2">Thông Tin Tài Khoản Đã Mua</h2>
                                        <div className="flex items-center mb-0">
                                            <div className="ml-4">
                                                <div className="font-bold text-base text-gray-600 text-wrap break-all">{clonethem}</div>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="ml-auto">
                                                <button
                                                    onClick={() => saochep()}
                                                    className="px-3 py-1 bg-blue-200 text-black text-base rounded-md hover:bg-blue-300 focus:outline-none focus:ring focus:border-blue-300"
                                                >
                                                    Sao Chép
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                )}
                            </div>
                        )}
                        <div className="mx-2">
                            <div className="max-w-2xl mx-2 mx-auto">
                                <div className="cards">
                                    <AdSense.Google
                                        client="ca-pub-4574266110812955"
                                        slot="5828045161"
                                        style={{ display: 'block' }}
                                        format="auto"
                                        responsive="true"
                                    />
                                </div> </div>
                        </div>
                        {/* Additional content */}
                        <br />
                    </div>
                </>)
            }
        </>
    );
};

export default Muataikhoan;
